export enum LyricsConfigError {
  UNSUPPORTED_EXTENSION_FOUND = 'UNSUPPORTED_EXTENSION_FOUND',
  UNKNOWN = 'UNKNOWN',
}
